/* istanbul ignore file */

export const WIDGET_CONSTANTS = {
    DEFAULT_REPORT_VIEW: { id: '-1', name: 'Default (no view selected)' },
    EMPTY_CATEGORY_LABEL: '(none)',
    CHART_ANGLE_KEY: 'count',
    CHART_LEGEND_ITEM_KEY: 'category',
    NO_DATA_EMPTY_STATE_HEADER: 'No widget data',
    NO_DATA_EMPTY_STATE_BODY: 'This widget has no data available to display at this time.',
    LOAD_ERROR_EMPTY_STATE_HEADER: 'Something went wrong',
    LOAD_ERROR_EMPTY_STATE_BODY: 'This widget couldn’t load due to a technical issue. Try refreshing the page.'
};
